import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Activity } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (location.state?.user) return children;

  if (loading) {
    return (
      <div className="min-h-screen bg-[var(--msml-bg)] flex items-center justify-center">
        <Activity className="w-8 h-8 text-[var(--msml-primary)] animate-pulse" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[var(--msml-bg)] flex items-center justify-center">
        <Activity className="w-8 h-8 text-[var(--msml-primary)] animate-pulse" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/workspace" replace />;
  return children;
}

/**
 * Route accessible by reviewer and admin roles.
 * Reviewers get read-only access.
 */
export function ReviewerRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[var(--msml-bg)] flex items-center justify-center">
        <Activity className="w-8 h-8 text-[var(--msml-primary)] animate-pulse" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (!['admin', 'reviewer'].includes(user.role)) return <Navigate to="/workspace" replace />;
  return children;
}
